/**
 * The same-origin base path the dashboard v1 VN variant is served under. Single source of truth for
 * a cross-app contract: the vn-pwa handoff navigates here ({@link ../auth/handoff}), the service
 * worker forces this tree network-only ({@link ../service-worker/cache-strategy}), and — in the
 * other repo — the dashboard's router mounts under it. The dashboard keeps its own copy of this
 * literal (the two repos share no runtime package); keep them in sync.
 */
export const APP_PATH = '/app'

/**
 * The path tree below the dashboard base, e.g. `/app/accounts`. Trailing slash on purpose so a
 * lookalike like `/application` is never swept in; the bare {@link APP_PATH} document is matched
 * explicitly by its consumers.
 */
export const APP_PATH_PREFIX = `${APP_PATH}/`
